/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { Flex, Radio, RadioGroup, Stack } from '@tonic-one/react';
import React, { useEffect } from 'react';
import { ProvisionApi } from '@Apis';
import { PolicyType } from '@Types/app';
import { useOrgStore } from '@Models/useOrgModel';

export const ServiceTypeSelection = ({
  selectedPolicyType,
  setSelectedPolicyType,
}: {
  selectedPolicyType: string;
  setSelectedPolicyType: (a: string) => void;
}) => {
  const [isShowMultiService, setIsShowMultiService] =
    React.useState<boolean>(false);
  const { t } = useTranslation();
  const { orgId } = useOrgStore();
  async function loadData() {
    try {
      const policyTypes = (
        await ProvisionApi.getProvisionedServicesByOrgId(orgId)
      ).data;
      const result = policyTypes.filter((item) =>
        [PolicyType.Exchange, PolicyType.Gmail].includes(item)
      );
      console.log(result);
      if (result.length === 2) {
        setIsShowMultiService(true);
        setSelectedPolicyType(PolicyType.Exchange.toString());
      } else if (result.length === 0) {
        setIsShowMultiService(false);
        setSelectedPolicyType(PolicyType.Exchange.toString());
      } else {
        setIsShowMultiService(false);
        setSelectedPolicyType(result[0].toString());
      }
    } catch (e) {
      console.log(e);
    }
  }
  const onChange = (value: string) => {
    console.log(value);
    setSelectedPolicyType(value);
  };

  useEffect(() => {
    (async function doCall() {
      await loadData();
    })();
  }, []);

  return (
    <Flex m="12px 0px">
      {isShowMultiService && (
        <RadioGroup
          defaultValue="1"
          value={selectedPolicyType}
          onChange={onChange}
        >
          <Stack direction="row" spacing="3x">
            <Radio name="aggressive" value="1">
              {t('common.service.exchange')}
            </Radio>
            <Radio name="normal" value="21">
              {t('common.service.gmail')}
            </Radio>
          </Stack>
        </RadioGroup>
      )}
    </Flex>
  );
};
